import React, { useEffect, useState } from "react";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import * as Yup from "yup";
import { MAX_FILE_SIZE, MAX_FILE_SIZE_MESSAGE, isValidFileType } from "../../../../helpers/fileValidationRules";
import { FieldArray, FormikProvider, useFormik } from "formik";

const validationSchema = Yup.object().shape({
   tyre: Yup.array().of(
      Yup.object().shape({
         odometerReading: Yup.number().required("Odometer Reading is required"),
         tyreType: Yup.string().required("Tyre Type Name is required"),
         tyreChangeDate: Yup.date().required("Tyre Change Date is required"),
         tyreAmount: Yup.number().required("tyre Amount is required"),
         tyreStationName: Yup.string().required("Tyre Station Name is required"),
         tyreBillUpload: Yup.mixed()
            .required("Tyre Bill is required")
            .test("is-valid-type", "Not a valid document type", (value) =>
               isValidFileType(value && value.name.toLowerCase(), "all")
            )
            .test(
               "is-valid-size",
               MAX_FILE_SIZE_MESSAGE,
               (value) => value && value.size <= MAX_FILE_SIZE
            ),
      })
   ),
});

const initialValues = {
   tyre: [
      {
         odometerReading: "",
         tyreType: "",
         tyreChangeDate: "",
         tyreAmount: "",
         tyreStationName: "",
         tyreBillUpload: null,
      },
   ],
};

function Tyre({ selectOptionData, step4Data, setStep4Data, setCurrentTabIndex }) {
   const [initialState, setInitialState] = useState(initialValues);

   const handleNext = (formData) => {
      setStep4Data(formData.tyre);
      setCurrentTabIndex((prev) => prev + 1);
   };

   useEffect(() => {
      if (step4Data?.length > 0) {
         setInitialState((prev) => ({ tyre: step4Data }));
      }
   }, []);

   const formik = useFormik({
      initialValues: initialState,
      validationSchema: validationSchema,
      enableReinitialize: true,
      onSubmit: handleNext,
   });

   const { errors, touched, values, getFieldProps, handleSubmit, setFieldValue } = formik;

   return (
      <FormikProvider value={formik}>
         <div
            className="tab-pane fade show active"
            id="3"
            role="tabpanel"
            aria-labelledby="3"
         >
            <div className="col-lg-12">
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Tyre</h3>
                  </div>
                  <div className="card-body">
                     <FieldArray
                        name="tyre"
                        render={(arrayHelpers) => (
                           <div>
                              {values?.tyre?.map?.((item, index) => {
                                 return (
                                    <div
                                       className={
                                          index < values.tyre.length - 1 &&
                                          values.tyre.length > 1
                                             ? "row border-bottom mb-4 pb-3"
                                             : "row"
                                       }
                                    >
                                       <div className="col-lg-4">
                                          <CustomInput
                                             require
                                             label="Odometer reading"
                                             inputType={"number"}
                                             id="odometerReading"
                                             placeholder="Enter Odometer reading"
                                             {...getFieldProps(
                                                `tyre[${index}].odometerReading`
                                             )}
                                             errors={
                                                Boolean(
                                                   touched?.tyre?.[index]?.odometerReading
                                                ) &&
                                                Boolean(
                                                   errors?.tyre?.[index]?.odometerReading
                                                )
                                             }
                                             message={
                                                errors?.tyre?.[index]?.odometerReading
                                             }
                                          />
                                       </div>
                                       <div className="col-lg-4">
                                          <CustomDropdown
                                             label="Tyre Type"
                                             optionData={selectOptionData}
                                             // value={tyreType}
                                             name={"tyreType"}
                                             value={item.tyreType}
                                             onChange={(e) => {
                                                setFieldValue(
                                                   `tyre[${index}].tyreType`,
                                                   e?.[0]?.value
                                                );
                                             }}
                                             errors={
                                                Boolean(
                                                   touched?.tyre?.[index]?.tyreType
                                                ) &&
                                                Boolean(errors?.tyre?.[index]?.tyreType)
                                             }
                                             message={errors?.tyre?.[index]?.tyreType}
                                          />
                                       </div>
                                       <div className="col-lg-4">
                                          <CustomDatePicker
                                             require
                                             label="Tyre Change Date"
                                             id="tyreChangeDate"
                                             placeholder="Select Tyre Change Date"
                                             {...getFieldProps(
                                                `tyre[${index}].tyreChangeDate`
                                             )}
                                             errors={
                                                Boolean(
                                                   touched?.tyre?.[index]?.tyreChangeDate
                                                ) &&
                                                Boolean(
                                                   errors?.tyre?.[index]?.tyreChangeDate
                                                )
                                             }
                                             message={
                                                errors?.tyre?.[index]?.tyreChangeDate
                                             }
                                          />
                                       </div>
                                       <div className="col-lg-4">
                                          <CustomInput
                                             require
                                             label="Tyre Amount"
                                             inputType={"number"}
                                             id="tyreAmount"
                                             placeholder="Enter Tyre Amount"
                                             {...getFieldProps(
                                                `tyre[${index}].tyreAmount`
                                             )}
                                             errors={
                                                Boolean(
                                                   touched?.tyre?.[index]?.tyreAmount
                                                ) &&
                                                Boolean(errors?.tyre?.[index]?.tyreAmount)
                                             }
                                             message={errors?.tyre?.[index]?.tyreAmount}
                                          />
                                       </div>
                                       <div className="col-lg-4">
                                          <CustomInput
                                             require
                                             label="Tyre Station Name"
                                             id="tyreStationName"
                                             placeholder="Enter Tyre Station Name"
                                             {...getFieldProps(
                                                `tyre[${index}].tyreStationName`
                                             )}
                                             errors={
                                                Boolean(
                                                   touched?.tyre?.[index]?.tyreStationName
                                                ) &&
                                                Boolean(
                                                   errors?.tyre?.[index]?.tyreStationName
                                                )
                                             }
                                             message={
                                                errors?.tyre?.[index]?.tyreStationName
                                             }
                                          />
                                       </div>

                                       <div className="col-lg-4">
                                          <label className="text-bold">
                                             Bill upload along with warranty status
                                             <span className="text-danger">*</span>
                                          </label>
                                          <CustomFileUpload
                                             accept=".jpg, .png, .jpeg, .csv, .xlsx, .pdf, .doc, .webp"
                                             name={"tyreBillUpload"}
                                             value={item.tyreBillUpload}
                                             onChange={(e) => {
                                                setFieldValue(
                                                   `tyre[${index}].tyreBillUpload`,
                                                   e.currentTarget.files[0]
                                                );
                                             }}
                                             errors={
                                                Boolean(
                                                   touched?.tyre?.[index]?.tyreBillUpload
                                                ) &&
                                                Boolean(
                                                   errors?.tyre?.[index]?.tyreBillUpload
                                                )
                                             }
                                             message={
                                                errors?.tyre?.[index]?.tyreBillUpload
                                             }
                                          />
                                       </div>
                                       <div className="col-12 mb-4">
                                          {values.tyre.length > 1 && (
                                             <button
                                                type="button"
                                                className="btn btn-danger float-left"
                                                onClick={() => {
                                                   arrayHelpers.remove(index);
                                                }}
                                             >
                                                <i className="fas fa-trash"></i> Delete
                                                item
                                             </button>
                                          )}
                                       </div>
                                    </div>
                                 );
                              })}
                           </div>
                        )}
                     />

                     <div className="row mt-3">
                        <div className="col-lg-6">
                           <button
                              type="button"
                              className="btn btn-primary float-left"
                              onClick={() => {
                                 setFieldValue("tyre", [
                                    ...values.tyre,
                                    {
                                       odometerReading: "",
                                       tyreType: "",
                                       tyreChangeDate: "",
                                       tyreAmount: "",
                                       tyreStationName: "",
                                       tyreBillUpload: null,
                                    },
                                 ]);
                              }}
                           >
                              <i className="fas fa-plus"></i> Add More
                           </button>
                        </div>
                     </div>
                  </div>

                  <div className="card-body">
                     <div
                        style={{
                           maxWidth: "min-content",
                           display: "flex",
                           marginLeft: "auto",
                        }}
                     >
                        <button
                           className="btn btn-secondary px-4 py-3"
                           type="button"
                           onClick={() => setCurrentTabIndex((prev) => prev - 1)}
                        >
                           <h6 className="mb-0 text-uppercase">Back</h6>
                        </button>
                        <button
                           className="btn btn-primary px-4 py-3 float-right ml-3"
                           type="button"
                           onClick={handleSubmit}
                        >
                           <h6 className="mb-0 text-uppercase">Next</h6>
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </FormikProvider>
   );
}

export default Tyre;
